<template>
<div class="editBar">
  <div class="font">
   <span>Font</span>
   <img src="../assets/img/left-arrow.svg" alt="">
  </div>
  <div class="font-size">
   <span>14</span>
   <img src="../assets/img/left-arrow.svg" alt="">
  </div>
  <div class="mixin-1">
   <div class="color">
    <span></span>
    <img src="../assets/img/left-arrow.svg" alt="">
   </div>
   <img src="../assets/img/B.svg" alt="">
   <img src="../assets/img/I.svg" alt="">
   <img src="../assets/img/U.svg" alt="">
   <img src="../assets/img/T.svg" alt="">
  </div>
  <div class="mixin-2">
   <img src="../assets/img/link.svg" alt="">
   <img src="../assets/img/unlink.svg" alt="">
  </div>
  <div class="mixin-3">
   <img src="../assets/img/Al-left.svg" alt="">
   <img src="../assets/img/Al-center.svg" alt="">
   <img src="../assets/img/Al-right.svg" alt="">
  </div>
  <div class="mixin-4">
   <img src="../assets/img/form.svg" alt="">
   <img src="../assets/img/list.svg" alt="">
   <img src="../assets/img/img.svg" alt="">
  </div>
</div>
</template>

<style lang="sass" scoped>
.editBar
  max-width: 730px
  width: 100%
  background-color: #F0ECE8
  display: flex
  justify-content: space-around
  padding: 10px 20px
  margin: 0px 0px 0px auto
  align-items: center
  border-radius: 0px 0px 20px 20px 
  .font,.font-size,.mixin-1,.mixin-2,.mixin-3,.mixin-4
   display: flex
   justify-content: center
   align-items: center
   img
    margin: 0px 5px
  .mixin-1
   .color
    span
     display: inline-block
     width: 10px
     height: 10px
     background-color: #8A7144
  .font,.font-size
   > span
    margin-right: 30px
</style>

<script>
export default {
 data() {
  return {
   
  }
 }
}
</script>